import { useEffect } from "react";
import { db } from "../../firebase/config";
import { useDispatch, useSelector } from "react-redux";
import { TalesParagraph } from "../types/TalesParagraph";
import { setHighlightData } from "../../store/highlight/actions/setData";
import { setHighlightError } from "../../store/highlight/actions/setError";
import { usedHooks } from "../../store/site/selectors";
import { addUsedHook } from "../../store/site/actions/addUsedHook";

export default function useHightlight() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useHightlight")) {
      dispatch(addUsedHook("useHightlight"));
      db.collection("highlight")
        .orderBy("order")
        .onSnapshot((snapshot) => {
          if (snapshot.empty) {
            dispatch(
              setHighlightError(
                "Non è stato trovato nessun evento in evidenza",
              ),
            );
          } else {
            let highlights: TalesParagraph[] = [];
            snapshot.docs.forEach((doc) => {
              highlights = [...highlights, doc.data() as TalesParagraph];
            });
            dispatch(setHighlightData(highlights));
          }
        });
    }
  }, [dispatch, hooks]);
}
